import { styled } from '@mui/material';

import { Skeleton } from '../../atoms/Skeleton';
import { TOPIC_TILE_SIZE } from './TopicListItem';

const Row = styled('li')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `${TOPIC_TILE_SIZE}px minmax(0, 1fr)`,
  columnGap: theme.spacing(1.5),
  alignItems: 'center',
  minHeight: theme.spacing(8),
  paddingBlock: theme.spacing(1),
  paddingInline: theme.spacing(2),
}));

const Lines = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

/** Placeholder mirroring a `TopicListItem` while the topics load. */
export function TopicListItemSkeleton() {
  return (
    <Row aria-hidden="true">
      <Skeleton variant="rounded" width={TOPIC_TILE_SIZE} height={TOPIC_TILE_SIZE} />
      <Lines>
        <Skeleton variant="text" width="55%" />
        <Skeleton variant="text" width="35%" />
      </Lines>
    </Row>
  );
}
